import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EntityRestrictionsService } from '../../../services/entity-restrictions.service';

@Component({
  selector: 'app-form-field-checkbox',
  templateUrl: './entity-restriction-checkbox-form-field.component.html',
  styleUrls: ['./entity-restriction-checkbox-form-field.component.scss'],
  standalone: false,
})
export class EntityRestrictionCheckboxFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: AvailabilityDTO;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  checkboxValue: boolean;

  constructor(private service: EntityRestrictionsService) {
    super();
  }

  onChange() {
    const copy: AvailabilityDTO = JSON.parse(JSON.stringify(this.data));
    copy.value = this.checkboxValue;
    if (this.data.value === this.checkboxValue) {
      this.service.remove(copy);
    } else {
      this.service.add(copy);
    }
  }

  ngOnInit(): void {
    this.checkboxValue = this.data.value;
  }
}

export interface AvailabilityDTO {
  value: boolean;
  countryId: number;
  type: 'SCRATCH' | 'LOTTO' | 'CASINO' | 'PROVIDER' | 'STUDIO';
  referenceId: string;
  label: string;
}
